/* eslint-disable react/prop-types */
import React, { useContext, useEffect, useState } from 'react'
import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CRow,
} from '@coreui/react'
import { cilLockLocked, cilUser } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import { useDispatch } from 'react-redux'
import { GlobalContext } from '../../context/GlobalState'
import { useHistory } from 'react-router-dom'
import { login } from '../../../Redux/Actions/authAction'
import { AppContext } from '../../context/app'
import { isEmpty } from 'lodash'

const Login = (props) => {
  const [emailId, setEmailId] = useState('')
  const [password, setPassword] = useState('')
  const onValueChange = (event, fn) => {
    fn(event.target.value)
  }

  const context = useContext(GlobalContext)
  const { accountObj } = useContext(AppContext)
  const dispatch = useDispatch()

  const handleLogin = async () => {
    let data = { email_id: emailId, password: password }
    const res = await dispatch(login(data))
    if (res?.success) {
      localStorage.setItem('sessionId', res.data.user_session.session_id)
      localStorage.setItem('customer_id', res.data.user.account)
      localStorage.setItem('accountId', res.data.user.account)
      context.updateLogin(res.data)
    }
  }
  let history = useHistory()

  useEffect(() => {
    console.log(context.signedIn, accountObj)
    if (context.signedIn && !isEmpty(accountObj)) {
      if (context.userObj?.is_forced_password_reset) {
        history.push('/reset-password')
        return
      }
      console.log('i am here')
      let x = props.location.state
      console.log('i am here', x)
      history.push(x === undefined || x === '/login' ? '/' : x)
    }
  }, [context.signedIn, accountObj])
  //
  // if (context.signedIn && !isEmpty(accountObj)) {
  //   let x = props.location.state
  //   if (x === undefined) {
  //     return <Redirect to="/dashboard" />
  //   } else {
  //     return <Redirect to={x} />
  //   }
  // } else {
  return (
    <>
      {!context.signedIn && (
        <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
          <CContainer>
            <CRow className="justify-content-center">
              <CCol md="6">
                {/* <CCardGroup> */}
                <CCard className="p-5">
                  <CCardBody>
                    <CForm>
                      <h1>Login</h1>
                      <p className="text-medium-emphasis">Sign In to your account</p>
                      <CInputGroup className="mb-3">
                        <CInputGroupText>
                          <CIcon icon={cilUser} />
                        </CInputGroupText>
                        <CFormInput
                          placeholder="Email"
                          autoComplete="emailId"
                          value={emailId}
                          onChange={(e) => onValueChange(e, setEmailId)}
                        />
                      </CInputGroup>
                      <CInputGroup className="mb-4">
                        <CInputGroupText>
                          <CIcon icon={cilLockLocked} />
                        </CInputGroupText>
                        <CFormInput
                          type="password"
                          placeholder="Password"
                          autoComplete="current-password"
                          value={password}
                          onChange={(e) => onValueChange(e, setPassword)}
                        />
                      </CInputGroup>
                      <CRow>
                        <CCol>
                          <CButton color="info" className="px-4 text-white" onClick={handleLogin}>
                            Login
                          </CButton>
                        </CCol>
                        <CCol className="text-right d-flex justify-content-end">
                          <CButton color="link" className="px-0">
                            Forgot password?
                          </CButton>
                        </CCol>
                      </CRow>
                    </CForm>
                  </CCardBody>
                </CCard>
              </CCol>
            </CRow>
          </CContainer>
        </div>
      )}
    </>
  )
  // }
}

export default Login
